import React from 'react';

const LockIcon = (p) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}>
        <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);

const MESSAGE = (label) => `You don't have access to ${label ? `"${label}"` : 'this page'}. Ask your admin to grant you permission.`;

// Click-time warning — used by Sidebar, Landing tiles, and portal search
// results when the user clicks something they don't have access to.
export function AccessLockedModal({ open, label, onClose }) {
    if (!open) return null;
    return (
        <div style={S.overlay} onClick={onClose}>
            <div onClick={e => e.stopPropagation()} style={S.modal}>
                <div style={S.iconWrap}><LockIcon width={22} height={22} /></div>
                <div style={S.title}>Access Restricted</div>
                <div style={S.message}>{MESSAGE(label)}</div>
                <button onClick={onClose} style={S.okBtn}>OK</button>
            </div>
        </div>
    );
}

// In-place fallback — rendered inside a domain layout when a user directly
// navigates/bookmarks a URL for a function they lack (no click to intercept).
export function LockedFunctionPage({ label }) {
    return (
        <div style={S.pageWrap}>
            <div style={S.pageIconWrap}><LockIcon width={30} height={30} /></div>
            <div style={S.pageTitle}>Access Restricted</div>
            <div style={S.pageMessage}>{MESSAGE(label)}</div>
        </div>
    );
}

const S = {
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(35,28,48,0.45)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    },
    modal: {
        background: '#fff', borderRadius: 16, padding: '28px 26px', maxWidth: 380, width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', textAlign: 'center', fontFamily: "'Poppins', sans-serif",
    },
    iconWrap: {
        width: 48, height: 48, borderRadius: 14, background: '#F5EDDC', color: '#9A7B3E',
        display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px',
    },
    title: { fontSize: 17, fontWeight: 700, color: '#231C30', marginBottom: 8 },
    message: { fontSize: 13.5, color: '#6B6379', lineHeight: 1.5, marginBottom: 20 },
    okBtn: {
        padding: '9px 24px', background: '#0F1F2E', color: '#fff', border: 'none',
        borderRadius: 9, fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
    },
    pageWrap: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '80px 20px', fontFamily: "'Poppins', sans-serif",
    },
    pageIconWrap: {
        width: 64, height: 64, borderRadius: 18, background: '#F5EDDC', color: '#9A7B3E',
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20,
    },
    pageTitle: { fontSize: 19, fontWeight: 700, color: '#231C30', marginBottom: 8 },
    pageMessage: { fontSize: 14, color: '#6B6379', lineHeight: 1.5, maxWidth: 360 },
};
